<template>
  <mt-popup v-model="moduleState.addTag" :modal=false popup-transition="popup-fade" class="page-module">
    <div class="btn-box" :class="{'finish': addTagLock}" @click="saveTag">
    <button class="save-btn">保存</button>
    </div>
    <div class="page-module">
      <app-header v-bind="headerConfig"></app-header>
      <ul class="options">
        <li class="item jump-ico" @click="cueTagSelect('', 101)">
          <div class="title">
            <span>完结状态</span>
          </div>
          <div class="val">
            <span v-text="isOver === 0? '更新中': '已完结'"></span>
          </div>
        </li>
        <li class="item jump-ico" @click="cueTagSelect('activity', 102)">
          <div class="title">
            <span>所属活动</span>
          </div>
          <div class="val">
            <span v-text="tag.tid === 0? '无': tag.tname"></span>
          </div>
        </li>
      </ul>
    </div>

    <rule-popup v-if="rulePopupSwitch" v-bind="rulePopupConf"></rule-popup>
    <radio-popup v-if="radioPopupSwitch" v-bind="radioPopupConf"></radio-popup>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {Toast} from 'mint-ui';
  import {mapState} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ProjectData} from '../store/ProjectData';
  import RulePopup from '../components/rule_popup';
  import RadioPopup from '../components/radio_popup';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: "add_tag",
    components: {
      'app-header': AppHeader,
      'rule-popup': RulePopup,
      'radio-popup': RadioPopup
    },
    computed: {
      ...mapState(['moduleState'])
    },
    store,
    data() {
      return {
        headerConfig: {
          title: '标签设置',
          isStoryMenu: false,
          backNote: '返回',
          backPage: '',
          closeModule: ComponentName.ADD_TAG
        },
        overOptions: null,
        rulePopupConf: null,
        radioPopupConf: null,
        rulePopupSwitch: false,
        radioPopupSwitch: false,
        projectData: new ProjectData(this),
        tag: Middle.ProjectData.header.tags,
        isOver: Middle.ProjectData.header.isOver,
        addTagLock: this.getOverStatus(),
        raidoTitle: ['所属活动', '完结状态'],
        tagOptions: {tname: '无', tid: 0, flag: true}
      }
    },
    methods: {
      getOverStatus() {
        return !!Middle.ProjectData.header.isOver
      },
      setTag() {
        var _header = Middle.ProjectData.header, _this = this;

        _header.isOver = _this.isOver;
        _header.tags = {
          tid: _this.tag.tid,
          tname: _this.tag.tname
        };

        _this.addTagLock = _this.getOverStatus();
        Middle.ServerPort.GetInstance().addNewTags();
      },
      saveTag() {
        let _this = this;

        if (this.addTagLock) {
          return;
        }
        if (Middle.ProjectData.header.gIndex === "") {
          return Toast({
            message: '请发布作品后，再来打标签吧~'
          });
        }
        if (!!this.isOver) {
          Methods.messageConfirm('', '设置完结后，将不可再修改标签，确认修改？', '确认', '取消', () => {
            _this.setTag();
          }, null)
        } else {
          _this.setTag();
        }
        Methods.checkChapterHash(99);
      },
      cueTagSelect(type, hash) {
        if (this.addTagLock) {
          return Toast({
            message: '已完结作品不可修改标签'
          });
        }
        var _this = this, _option = type === 'activity'? _this.tagOptions: this.overOptions;

        this.radioPopupConf = {
          type,
          title: type === 'activity'? '所属活动':'完结状态',
          options: _option,
          btnConf: [
            {
              text: '取消',
              callBack: () => {
                this.radioPopupSwitch = false;
              }
            },
            {
              text: '确定',
              callBack: () => {
                if (type === 'activity') {
                  // _this.tag = item;
                  let itemSign = null;

                  _this.tagOptions.forEach(function (_item) {
                    if (_item.flag) {
                      _this.tag = _item;
                      itemSign = _item;
                    }
                  });
                  if (itemSign.tag_rule && itemSign.tag_rule !== '') {
                    _this.rulePopupConf = {
                      title: '活动规则',
                      desc: itemSign.tag_rule,
                      cancelCallBack: () => {
                        _this.rulePopupSwitch = false;
                      }
                    };

                    _this.rulePopupSwitch = true;
                  }
                } else {
                  _this.overOptions.forEach(function(_item, i) {
                    if (_item.flag) {
                      _this.isOver = _item.tid;
                    }
                  });
                }
                _this.radioPopupSwitch = false;
              }
            }
          ],
          radioSelect: (item, index) => {
            _option.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(_option[index], 'flag', true);
          },
        };
        _this.radioPopupSwitch = true;
        Methods.checkChapterHash(hash);
      }
    },
    created() {
      this.addTagLock = this.getOverStatus();
      this.overOptions = [
        {tname: '更新中', 'flag': this.isOver === 0, tid: 0},
        {tname: '完结', 'flag': this.isOver === 1, tid: 1}
      ];

      Middle.ServerPort.GetInstance().getGameTags((res) => {
        var _default = {tname: '无', tid: 0};

        res.data.unshift(_default);
        for (let i in res.data) {
          if (res.data[i].tid === Middle.ProjectData.header.tags.tid) {
            Vue.set(res.data[i], 'flag', true);
          }
        }
        this.tagOptions = res.data;
      })
    }
  }
</script>

<style scoped>
  @import "../style/css/add_tag.css";
</style>



// WEBPACK FOOTER //
// src/components/add_tag.vue